import React, { Component } from 'react';
import Slide from '@material-ui/core/Slide';

import '../../../chat.css';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import SpeechBubble from '../speechBubble/SpeechBubble';
import MessageTypeEnum from '../../../config/constants/MessageTypeEnum';
import LineBreakTypeEnum from "../../../config/constants/LineBreakTypeEnum";
import {Carousel} from "react-responsive-carousel";
import VizSensor from 'react-visibility-sensor';
import LinearProgress from "@material-ui/core/LinearProgress";
import "./SearchBotChatField.css"
import LayoutTypeEnum from "../../../config/constants/LayoutTypeEnum";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import LanguageIcon from '@material-ui/icons/Language';
import Card from '@material-ui/core/Card';
import PublicIcon from '@material-ui/icons/Public'; // "Better looking" globe
import { getLocalizationLanguageCode } from '../../../util/localization';
import { Button } from '@material-ui/core';
import ChatBotChatField from '../ChatBotChatField';
import {isMobile} from "react-device-detect";
import LanguageSelector from "../../topBar/languageSelector/LanguageSelector";
import Localization from "../../../config/localization/Localization";
import HelpIcon from "@material-ui/icons/HelpOutline";

/**
 * Class for the chatfield containing the speechbubbles.
 */
class SearchBotChatField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lastChatFieldContentHeight: 0,
            scrollToOldHeight: false,
            loadMoreEnabled: false,
            chatMenuItemList: [],
            lastMessageLength: 0,
            intervalId: null
        };
        this.handleLoadMoreVisibilityChange = this.handleLoadMoreVisibilityChange.bind(this)
    }

    /*
     * Returns a speechbubble that shows a user or bot is writing.
     */
    getIsWritingSpeechBubble = (isUser) => {
        return  {
            messageList: [
                {
                    messageType: MessageTypeEnum.text,
                    content: '<div class="bot-writing-message">' +
                        '<span></span><span></span><span></span>' +
                        '</div>'
                }
            ],
            index: 0,
            isUser: isUser,
            botWriting: true
        };
    };

    /**
     * Scrolls to the top of the chatfield.
     */
    scrollToTop = () => {
        if (this.messagesEnd) {
            this.chatFieldParentContainerDiv.scrollTo({ top: this.chatFieldParentContainerDiv.scrollHeight, behavior: 'smooth' });
        }
    };

    handleInputOnClick = (e) => {
        // const element = document.querySelector('#search-bot-chat-field-container-parent');
        /*             if (element) {
                        element.style.display = 'none';
                    } */
        this.initializeChatMenuItems(false)
    }



    getChatFieldContentHeight= () => {
        // Checks if Internet Explorer
        const ua = window.navigator.userAgent;
        const isIe = ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0;

        if (!this.chatFieldContentDiv) {
            return null;
        }

        return isIe ? this.chatFieldContentDiv.scrollHeight : this.chatFieldContentDiv.clientHeight;
    };

    /**
     * Loads more chat messages when start of messages div is scrolled into view.
     */
    handleLoadMoreVisibilityChange = (isVisible) => {
        if (isVisible && this.state.loadMoreEnabled)
        {
            this.setState({lastChatFieldContentHeight: 0, scrollToOldHeight: true}, () => {
                this.props.loadMoreSpeechBubble();
            });
        }
    };

    /**
     * Checks every 200 ms if the height of the chatfield has changed and scrolls top the top if it has.
     * This fix is because of componentDidUpdate() does not get called if for example
     * a height change is caused by a youtube video initializing in a child component.
     */
    componentDidUpdate(prevProps) {
        // If chatConfig or language changes, re-initialize menu items
        if (prevProps.chatConfig !== this.props.chatConfig || prevProps.language !== this.props.language) {
            /* this.initializeChatMenuItems(); */
        }

        // Scroll to top if switching to ChatBotChatField (withMemory enabled)
        if (!prevProps.chatConfig.withMemory && this.props.chatConfig.withMemory) {
            this.scrollToTop();
        }
    }

    componentDidMount = () => {
        /*         this.initializeChatMenuItems(); */
        const that = this;

        const intervalId = setInterval(() => {
            if (that.chatFieldContentDiv == null) {
                return;
            }

            const chatFieldContentHeight = this.getChatFieldContentHeight();

            if (chatFieldContentHeight && chatFieldContentHeight !== that.state.lastChatFieldContentHeight) {

                if (that.state.loadMoreEnabled === false) {
                    setTimeout(() => {
                        this.setState({loadMoreEnabled: true});
                    }, 1000)
                }

                if (this.props.loadToEnd) {
                    that.scrollToTop();

                } else if (this.state.scrollToOldHeight) {
                    that.chatFieldParentContainerDiv.scrollTop = chatFieldContentHeight - that.state.lastChatFieldContentHeight;
                }

                that.setState({lastChatFieldContentHeight: chatFieldContentHeight, scrollToOldHeight: false});
            }
        }, 200);

        this.setState({ intervalId });

        setTimeout(() => {
            this.setState({loadMoreEnabled: true});
        }, 2000);

        if (this.props.chatConfig.withMemory) {
            setTimeout(() => this.scrollToTop(), 100);
        }
    };

    componentWillUnmount() {
        if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
        }
    }

    initializeChatMenuItems = (reset) => {
        if(reset){
            if (this.props.chatConfig && this.props.language) {
                const localizationCode = getLocalizationLanguageCode(
                    this.props.language ? this.props.language.languageCode : null
                );

                const chatMenuItemList = this.props.chatConfig.chatMenuItemList.filter((chatMenuItem) => {
                    return chatMenuItem.languageCode === this.props.language.languageCode;
                }).sort((a, b) => a.index - b.index);

                this.setState({ chatMenuItemList }, () => {
                    // Defer the resize call to ensure layout has settled
                    setTimeout(() => {
                        this.props.resizeChatContainer(chatMenuItemList.length);
                    }, 0);
                });
            } else {
                this.setState({ chatMenuItemList: [] });
            }
        }
        else {
            this.setState({ chatMenuItemList: [] });
        }
    };


    handleMenuItemClick = async (menuItem) => {

        this.props.setShowSearchBotChatField(true);

        await this.props.onMenuItemClick(menuItem);

        this.setState({ chatMenuItemList: [] });
    };


    resetChatMenuItems = () => {
        this.setState({ chatMenuItemList: [] });
    };

       /**
     * Returns an array of the rows of speechbubbles.
     * Here continuous suggestions from the same response is added to the same rows.
     * @returns {[]|Array}
     */
    getSpeechBubbleRowList = () => {
        if (!this.props.speechBubbleList) {
            return [];
        }

        let rowList = [];
        let row = [];
        this.props.speechBubbleList.forEach((speechBubble, index, array) => {
            if (!speechBubble.hidden) {
                row.push(speechBubble);
            }

            const flex = (index + 1 <= array.length - 1) &&
                speechBubble.chatResponseId != null && array[index + 1].chatResponseId != null &&
                (speechBubble.chatResponseId === array[index + 1].chatResponseId) &&
                ((speechBubble.suggestion != null && array[index + 1].suggestion != null) ||
                    (speechBubble.lineBreakType !== LineBreakTypeEnum.notSet &&
                        speechBubble.lineBreakType !== LineBreakTypeEnum.newLine &&
                        speechBubble.lineBreakType === array[index + 1].lineBreakType));

            if (flex === false) {
                if (row.length > 0) {
                    rowList.push(row);
                }

                row = [];
            }
        });

        return rowList;
    };

    renderSpeechBubbleRow = (speechBubbleRow) => {
        // Determine if the row has any non-hidden messages and calculate the last message length
        /*         const nonHiddenMessages = speechBubbleRow
                    .flatMap((speechBubble) => speechBubble.messageList)
                    .filter((message) => !message.hidden);

                if (nonHiddenMessages.length > 0) {
                    const lastMessage = nonHiddenMessages[nonHiddenMessages.length - 1];
                    // Update the state with the length of the last message only if it has changed
                    //HER skal der være en condition !chatConfig.withMemory
                    if (lastMessage.content.length !== this.state.lastMessageLength && (this.props.chatConfig.withMemory)) {
                        this.setState({ lastMessageLength: lastMessage.content.length });
                    }
                } */
        return (
            speechBubbleRow.map((speechBubble, index) => (
                speechBubble.hidden ? null :
                    (speechBubble.messageList.every((message) => (message.hidden === true )) ? null :
                            <Slide direction={speechBubble.isUser ? 'left' : 'right'} in={true} key={index}>
                                <SpeechBubble
                                    token={this.props.token}
                                    showAvatar={false}
                                    speechBubble={speechBubble}
                                    chatConfig={this.props.chatConfig}
                                    sendMessage={this.props.sendMessage}
                                    sendIntent={this.props.sendIntent}
                                    sendChatResponseFeedback={this.props.sendChatResponseFeedback}
                                    spectatorMode={this.props.spectatorMode}
                                    language={this.props.language}
                                    welcomePreviewEnabled={this.props.welcomePreviewEnabled}
                                    layoutMode={LayoutTypeEnum.searchBot}
                                    lastRow={speechBubbleRow.lastRow && speechBubbleRow.length - 1 === index}
                                />
                            </Slide>
                    )
            ))
        );
    };



    clearSpeechBubble = () => {

    }

    render() {

        if (!this.props.showSearchBotChatField) {

            return null;
        }
        const { chatConfig, sourcesList } = this.props;
        const withMemory = chatConfig?.withMemory;
        let chatMenuItemList = this.state.chatMenuItemList;
        // Create the menu buttons as the content for the speech bubble
        const menuButtons = chatMenuItemList.slice(0, 3).map((menuItem, index) => (
            <button
                key={index}
                onClick={() => this.handleMenuItemClick(menuItem)}
                style={{
                    margin: '5px',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ccc',
                    background: '#f9f9f9',
                    cursor: 'pointer',
                }}
            >
                {menuItem.displayName || `Menu Item ${index + 1}`}
            </button>
        ));

        const menuList = (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                marginBottom: '10px',
                padding: '0px',
                background: 'transparent',
                width: '100%',
                height: '100%',
            }}>
                <List component="nav" style={{
                    width: '100%',
                    borderRadius: '4px',
                }}>
                    {chatMenuItemList.map((menuItem, index) => (
                        <ListItem
                            key={index}
                            button
                            onClick={() => this.handleMenuItemClick(menuItem)}
                            style={{
                                padding: '10px',
                                borderBottom: '1px solid #eee',
                                height: '35px',
                                /* borderColor: this.props.chatConfig.speechBubbleUserColor,  */

                            }}
                            onMouseOver={(event) => event.currentTarget.style.background = '#e0e0e0'}
                            onMouseOut={(event) => event.currentTarget.style.background = 'transparent'}
                        >
                            <ListItemText
                                primary={menuItem.displayName || `Menu Item ${index + 1}`}
                                primaryTypographyProps={{
                                    style: {
                                        color: this.props.chatConfig.suggestionFontColor,
                                        fontSize:'13px'
                                    }
                                }}
                            />
                        </ListItem>
                    ))}
                </List>
            </div>
        );



        const speechBubbleRowList = this.getSpeechBubbleRowList();
        let sortedSpeechBubbleRowList = []

        let tempSpeechBubbleRowList = [];
        for(let i = 0; i < speechBubbleRowList.length; i++){

            if(speechBubbleRowList[i][0] != null){
                if(speechBubbleRowList[i][0].isUser){
                    if(tempSpeechBubbleRowList.length > 0){
                        tempSpeechBubbleRowList[tempSpeechBubbleRowList.length - 1].lastRow = true;
                        sortedSpeechBubbleRowList.push(tempSpeechBubbleRowList)
                        tempSpeechBubbleRowList = [];
                    }
                    sortedSpeechBubbleRowList.push([speechBubbleRowList[i]])
                } else if(tempSpeechBubbleRowList.length === 0 || speechBubbleRowList[i][0].dropId === tempSpeechBubbleRowList[0][0].dropId){
                    tempSpeechBubbleRowList.push(speechBubbleRowList[i])
                } else {
                    tempSpeechBubbleRowList[tempSpeechBubbleRowList.length - 1].lastRow = true;
                    sortedSpeechBubbleRowList.push(tempSpeechBubbleRowList)
                    tempSpeechBubbleRowList = [];
                    tempSpeechBubbleRowList.push(speechBubbleRowList[i]);
                }

            }
        }

        if(tempSpeechBubbleRowList.length > 0){
            tempSpeechBubbleRowList[tempSpeechBubbleRowList.length - 1].lastRow = true;
            sortedSpeechBubbleRowList.push(tempSpeechBubbleRowList)
        }

        sortedSpeechBubbleRowList.reverse();
        sortedSpeechBubbleRowList = sortedSpeechBubbleRowList.flat();

        // let searchBotAnswerRowList = [];
        // for(let i = speechBubbleRowList.length - 1; i >= 0; i--){
        //     if(speechBubbleRowList[i][0] != null) {
        //         if (speechBubbleRowList[i][0].isUser) {
        //             if (searchBotAnswerRowList.length > 0) {
        //                 searchBotAnswerRowList[0].lastRow = true;
        //                 const lastRow = searchBotAnswerRowList.find(answerRow => answerRow[0].suggestion == null)
        //                 if(lastRow){
        //                     lastRow.lastRow = true;
        //                 }
        //                 searchBotAnswerRowList.reverse();
        //                 sortedSpeechBubbleRowList.push(...searchBotAnswerRowList)
        //                 sortedSpeechBubbleRowList.push(speechBubbleRowList[i])
        //                 searchBotAnswerRowList = [];
        //             } else {
        //                 sortedSpeechBubbleRowList.push(speechBubbleRowList[i])
        //             }
        //         } else {
        //             if(speechBubbleRowList[i][0].chatResponseId === "00000000-0000-0000-0000-000000000000"){
        //                 sortedSpeechBubbleRowList.push(speechBubbleRowList[i])
        //             } else {
        //                 if(searchBotAnswerRowList.length > 0 && searchBotAnswerRowList[0][0].chatResponseId !== speechBubbleRowList[i][0].chatResponseId){
        //                     const lastRow = searchBotAnswerRowList.find(answerRow => answerRow[0].suggestion == null)
        //                     if(lastRow){
        //                         lastRow.lastRow = true;
        //                     }
        //                     searchBotAnswerRowList.reverse();
        //                     sortedSpeechBubbleRowList.push(...searchBotAnswerRowList)
        //                     searchBotAnswerRowList = [];
        //                 }
        //                 searchBotAnswerRowList.push(speechBubbleRowList[i])
        //                 if(i === speechBubbleRowList.length - 1){
        //                     sortedSpeechBubbleRowList.push(...searchBotAnswerRowList)
        //                 }
        //             }
        //         }
        //     }
        // }


        if (sortedSpeechBubbleRowList.length > 0 && !(this.props.chatConfig.withMemory)) {
            sortedSpeechBubbleRowList = [sortedSpeechBubbleRowList[sortedSpeechBubbleRowList.length - 1]];
        }
        if(this.props.chatConfig.withMemory){
            sortedSpeechBubbleRowList = sortedSpeechBubbleRowList.reverse();
        }

        return (
            <div
                id={'search-bot-chat-field-container-parent'}
                ref={(div) => (this.chatFieldParentContainerDiv = div)}
                style={{ display: this.props.showSearchBotChatField ?  'flex' : 'none', flexDirection: 'column', height: '100%' }}
            >
                {/* The top disclaimers row, with an X on the right */}
                <div

                style={{backgroundColor: this.props.chatConfig.topBackgroundColor ? this.props.chatConfig.topBackgroundColor :'white' , color: this.props.chatConfig.topFontColor? this.props.chatConfig.topFontColor : "black",  display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between' }}

                className= {this.props.chatConfig.withMemory ? "AI-warningMemory" : "AI-warning"}

                >
                    {/* LEFT container */}
                    <div style={{ flex: '0 1 auto' }}>
                        {this.props.chatConfig.openDownwards ? (
                            <span className="AI-warning-text">
                            {this.props.currentLanguage.disclaimer || ''}
                        </span>
                        ) : null}
                    </div>

                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyItems: 'center'}}>
                        
                    <LanguageSelector isSearch={true} language={this.props.language}
                                      languageList={this.props.languageList}
                                      languageSelected={this.props.languageSelected}/>
                        
                    <Button   style={{
                               color: this.props.chatConfig.startButtonFillColor,
                        backgroundColor: this.props.chatConfig.startButtonBackgroundColor ? this.props.chatConfig.startButtonBackgroundColor :'transparent'
                    }}
                              title={Localization[getLocalizationLanguageCode(this.props.language ? this.props.language.languageCode : null)]['topBar.title.help']} tabIndex="7" id={'info-page-toggle-button-searchbot'} onClick={() => this.props.toggleShowInfoPage()}>
                        <HelpIcon  />
                    </Button>
                        <Button
                            onClick={() => this.props.setShowSearchBotChatField(false)}
                            style={{
                                fontSize: '24px',
                                minWidth: 'auto',
                                padding: '4px 8px',
                                lineHeight: '1',
                                color: this.props.chatConfig.startButtonFillColor,
                                backgroundColor: this.props.chatConfig.startButtonBackgroundColor ? this.props.chatConfig.startButtonBackgroundColor :'transparent'
                            }}
                            aria-label="Close Chat"
                        >
                            &times;
                        </Button>
                    </div>
                </div>



                {/* If scrolled up to load older messages, show a progress bar */}
                {this.state.scrollToOldHeight ? (
                    <div id={'chat-field-load-container'}>
                        <LinearProgress />
                    </div>
                ) : null}

                <div
                    id={'search-bot-chat-field-content-container'}
                    ref={(div) => (this.chatFieldContentDiv = div)}
                    style={{ flex: 1, overflowY: 'auto' }}
                >
                    <div
                        style={{ float: 'left', clear: 'both' }}
                        ref={(el) => {
                            this.messagesEnd = el;
                        }}
                    />

                    {/*
                      If withMemory = true, we want to render the entire
                      ChatBotChatField layout. Otherwise, we do the "resume"
                      logic below.
                    */}
                    {this.props.chatConfig.withMemory ? ( this.props.speechBubbleList && this.props.speechBubbleList.length>0 &&
                        /*
                          RENDER THE FULL ChatBotChatField
                          (the normal bottom-scroll chat layout)
                        */
                        <ChatBotChatField
                            token={this.props.token}
                            speechBubbleList={this.props.speechBubbleList}
                            botWriting={this.props.botWriting}
                            userWriting={this.props.userWriting}
                            loadMore={this.props.loadMore}
                            loadToEnd={this.props.loadToEnd}
                            loadMoreSpeechBubble={this.props.loadMoreSpeechBubble}
                            chatConfig={this.props.chatConfig}
                            sendMessage={this.props.sendMessage}
                            sendIntent={this.props.sendIntent}
                            sendChatResponseFeedback={this.props.sendChatResponseFeedback}
                            spectatorMode={this.props.spectatorMode}
                            language={this.props.language}
                            welcomePreviewEnabled={this.props.welcomePreviewEnabled}
                        />
                    ) : (
                        /*
                          RENDER THE "RESUME" LOGIC (if withMemory = false)
                        */
                        ((this.props.botWriting || this.props.speechBubbleList.length > 0) &&
                        <div className="search-bot-speech-container">
                            {/* Only show “Resumé” if there's something to display */}
                            {(this.props.botWriting || sortedSpeechBubbleRowList.length > 0) ? (
                                <div className="search-bot-speech-container-summerized">
                                    {/*<svg*/}
                                    {/*    width="17"*/}
                                    {/*    height="17"*/}
                                    {/*    viewBox="0 0 32 32"*/}
                                    {/*    xmlns="http://www.w3.org/2000/svg"*/}
                                    {/*>*/}
                                    {/*    <defs>*/}
                                    {/*        <linearGradient*/}
                                    {/*            id="gradient"*/}
                                    {/*            x1="0%"*/}
                                    {/*            y1="0%"*/}
                                    {/*            x2="100%"*/}
                                    {/*            y2="100%"*/}
                                    {/*        >*/}
                                    {/*            <stop*/}
                                    {/*                offset="0%"*/}
                                    {/*                stopColor="rgb(33,123,254)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="14%"*/}
                                    {/*                stopColor="rgb(20,133,252)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="27%"*/}
                                    {/*                stopColor="rgb(7,142,251)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="52%"*/}
                                    {/*                stopColor="rgb(84,143,253)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="78%"*/}
                                    {/*                stopColor="rgb(161,144,255)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="89%"*/}
                                    {/*                stopColor="rgb(175,148,254)"*/}
                                    {/*            />*/}
                                    {/*            <stop*/}
                                    {/*                offset="100%"*/}
                                    {/*                stopColor="rgb(189,153,254)"*/}
                                    {/*            />*/}
                                    {/*        </linearGradient>*/}
                                    {/*    </defs>*/}
                                    {/*    <polygon*/}
                                    {/*        fill="url(#gradient)"*/}
                                    {/*        points="*/}
                                    {/*            16,2*/}
                                    {/*            20,11*/}
                                    {/*            31,12*/}
                                    {/*            22,18*/}
                                    {/*            26,28*/}
                                    {/*            16,22*/}
                                    {/*            6,28*/}
                                    {/*            10,18*/}
                                    {/*            1,12*/}
                                    {/*            12,11*/}
                                    {/*        "*/}
                                    {/*    />*/}
                                    {/*</svg>*/}
                                    Resultat
                                </div>
                            ) : null}

                            {/* If the bot is writing, show a typing bubble */}
                            {this.props.botWriting ? (
                                <div id={'search-bot-chat-summarized'}>
                                    <SpeechBubble
                                        token={this.props.token}
                                        showAvatar={false}
                                        speechBubble={this.getIsWritingSpeechBubble(false)}
                                        chatConfig={this.props.chatConfig}
                                        language={this.props.language}
                                        layoutMode={LayoutTypeEnum.searchBot}
                                    />
                                </div>
                            ) : null}

                            {/* If the user is writing, show a typing bubble */}
                            {this.props.userWriting ? (
                                <div id={'search-bot-chat-summarized'}>
                                    <SpeechBubble
                                        token={this.props.token}
                                        speechBubble={this.getIsWritingSpeechBubble(true)}
                                        chatConfig={this.props.chatConfig}
                                        language={this.props.language}
                                        layoutMode={LayoutTypeEnum.searchBot}
                                    />
                                </div>
                            ) : null}

                            {/* Render the final sorted speech bubble rows */}
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                {sortedSpeechBubbleRowList.map((speechBubbleRow, index) => (
                                    <div
                                        className={
                                            speechBubbleRow[0].suggestion == null
                                                ? 'search-bot-chat-field-speechbubble-row'
                                                : 'search-bot-chat-field-suggestion-speechbubble-row'
                                        }
                                        key={index}
                                    >
                                        {speechBubbleRow[0].lineBreakType ===
                                        LineBreakTypeEnum.carousel ? (
                                            <Carousel
                                                useKeyboardArrows
                                                centerMode
                                                autoPlay
                                                showArrows={true}
                                                showThumbs={false}
                                                showStatus={false}
                                                centerSlidePercentage={85}
                                                className={'speech-bubble-carousel-slide'}
                                            >
                                                {this.renderSpeechBubbleRow(speechBubbleRow)}
                                            </Carousel>
                                        ) : (
                                            this.renderSpeechBubbleRow(speechBubbleRow)
                                        )}
                                    </div>
                                ))}
                            </div>

                            {/* Optionally show a VizSensor to load more when scrolled up */}
                            {this.props.loadMore && speechBubbleRowList.length > 0 ? (
                                <VizSensor onChange={this.handleLoadMoreVisibilityChange}>
                                    <div style={{ width: '100%', height: '1px' }} />
                                </VizSensor>
                            ) : null}
                        </div>)
                    )}

                    {/* Menu items appear in BOTH modes, below the main chat area */}
                    {this.props.speechBubbleList.length == 0 && this.state.chatMenuItemList.length > 0 ? (
                        <div style={{ margin: 0, padding: 0 }}>{menuList}</div>
                    ) : null}

                    {sourcesList && sourcesList.length > 0 && chatConfig.showSources ? (
                        <div className="sourceDiv" style={{ width: '100%', boxSizing: 'border-box'}}>
                            {/* Optionally uncomment the title if needed */}
                            {/* <div className="sourceDivTitle">Fundne kilder</div> */}
                            <List style={{ width: '100%', padding: 0, margin: 0, boxSizing: 'border-box' }}>
                                {sourcesList.map(([content, title, url], index) => (
                                    <ListItem
                                        key={index}
                                        style={{
                                            padding: 0,
                                            border: 'none',
                                            boxSizing: 'border-box',
                                            width: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            margin: chatConfig.showSourcesWithContent ?'10px 0' : '0px 0',
                                            borderTop: index === 0 ? 'none' : '1px solid #e0e0e0'
                                        }}
                                    >
                                        {(url || title || content)  && <div
                                            style={{
                                                width: '100%',
                                                padding: chatConfig.showSourcesWithContent ?'15px 15px 5px 15px' : '10px 0',
                                                boxSizing: 'border-box',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '8px',
                                                backgroundColor: '#fff' // Optional: Add background to differentiate items
                                            }}
                                        >
                                            { url &&
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'nowrap' }}>
                                                {/* Changed 'flexWrap' from 'wrap' to 'nowrap' to prevent wrapping */}
                                                <PublicIcon style={{ color: '#999', flexShrink: 0 }} />
                                                <a
                                                    href={url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        fontFamily: this.props.chatConfig?.font || 'inherit',
                                                        fontSize: '0.8rem',
                                                        color: this.props.chatConfig?.fontUserColor || '#3f51b5',
                                                        textDecoration: 'none',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        maxWidth: '100%',
                                                        flex: '1 1 auto',
                                                        minWidth: '0' // Added to allow the link to shrink properly
                                                    }}
                                                    title={url}
                                                >
                                                    {url}
                                                </a>
                                            </div>}


                                            {chatConfig.showSourcesWithContent &&
                                                <>
                                            {/* Title */}
                                            <div
                                                style={{
                                                    fontFamily: this.props.chatConfig?.font || 'inherit',
                                                    fontSize: '13px',
                                                    fontWeight: 600,
                                                    color: this.props.chatConfig?.fontUserColor || '#333',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    maxWidth: '100%'
                                                }}

                                            >
                                                {title}
                                            </div>

                                            {/* Content */}
                                            <div
                                                style={{
                                                    fontFamily: this.props.chatConfig?.font || 'inherit',
                                                    fontSize: '0.8rem',
                                                    lineHeight: 1.4,
                                                    color: this.props.chatConfig?.fontUserColor || '#444',
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: 3,
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '100%'
                                                }}

                                            >
                                                {content}
                                            </div>
                                                </>}
                                        </div>
                                        }
                                    </ListItem>
                                ))}
                            </List>
                        </div>
                    ) : null}


                    {/* Footer text */}
                    <div
                        className="indialog-searchbot-footer"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between', 
                            alignItems: 'center',
                            bottom: this.props.chatConfig.openDownwards ? '10px' : '60px'
                        }}
                    >

                        <span className="AI-warning-text" style={{ paddingLeft: '10px' }}>
                         { !this.props.chatConfig.openDownwards &&  this.props.currentLanguage.disclaimer || ''}
                        </span>

                        {this.props.chatConfig.showPoweredBy  &&
                        <span>Powered by InDialog.ai</span>}
                    </div>


                </div>
            </div>
        );
    }
}
export default SearchBotChatField;